import * as api from '../../../requests'
import {
  SET_CURRENT_USER,
  SET_DB_RECEIPT_DETAILS,
  SET_RECEIPT_ITEM_TYPES,
  SET_RECEIPT_ITEM_TYPE_ENUM,
  SET_RECEIPT_DLNS,
  SET_FAILED_VALIDATION,
  SET_REDIRECT_BACK_TO,
  SET_REFUND_STATUS,
  SET_LOADING_EXISTING,
} from './ReceiptValidationReducer'
import { setErrorToast, setSuccessToast } from '../../../actions'

export const getDbReceiptDetails = (receiptId) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_LOADING_EXISTING, loadingExisting: true })
    api.FETCH_RECEIPT_DETAILS(
      receiptId,
      (receipt) => {
        dispatch({ type: SET_DB_RECEIPT_DETAILS, receipt: receipt })
        dispatch({ type: SET_LOADING_EXISTING, loadingExisting: false })
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast(`Failed to retrieve info for receipt #${receiptId}`))
        dispatch({ type: SET_LOADING_EXISTING, loadingExisting: false })
      }
    )
  }
}

export const updateReceipt = (receipt, callback, errorCallback) => {
  let payments = []
  receipt.Payments.forEach((payment) => {
    if (!payment.Type) {
      payments.push(payment)
    }
  })

  if (payments.length > 0) {
    return (dispatch, getState) => {
      dispatch({ type: SET_FAILED_VALIDATION })
      dispatch(
        setErrorToast(
          'Payment information needs to be entered in for all the payments listed above!'
        )
      )
    }
  }

  return (dispatch, getState) => {
    api.SAVE_RECEIPT_DATA(
      receipt,
      (newData) => {
        dispatch(setSuccessToast('Receipt Successfully Saved'))

        // api.DOWNLOAD_RECEIPT_PDF(
        //   newData.ReceiptNum,
        //   (data) => {
        //     var arrrayBuffer = base64ToArrayBuffer(data)
        //     var blob = new Blob([arrrayBuffer], { type: 'application/pdf' })
        //     var link = window.URL.createObjectURL(blob)
        //     window.open(link, '_blank')
        //   },
        //   (err) => console.error(err)
        // )

        if (!process.env.BYPASS_SAVING_RECEIPT_TO_AZURE && receipt.isLastImageGroup) {
          api.SAVE_TO_AZURE(
            newData,
            () => {
              // console.log('Saved to Azure successfully called')
            },
            (err) => console.error(err)
          )
        }
        dispatch({ type: SET_DB_RECEIPT_DETAILS, receipt: newData })
        callback(newData)
      },
      (err) => {
        dispatch(setErrorToast(err.ExceptionMessage))
        console.error(err)
        errorCallback(err)
      }
    )
  }
}

export const tieReceiptToImageEnvelope = (receipt, wvItem, callback, errorCallback) => {
  return (dispatch) => {
    api.TIE_RECEIPT_TO_IMAGE_ENVELOPE(
      receipt.ReceiptID,
      wvItem.ImageEnvelopeId,
      wvItem.WorkViewItemId,
      () => {
        callback()
      },
      (err) => errorCallback(err)
    )
  }
}

export const getReceiptItemTypes = () => {
  return (dispatch) => {
    api.FETCH_RECEIPT_ITEM_TYPES(
      (types) => {
        dispatch({ type: SET_RECEIPT_ITEM_TYPES, types: types })
      },
      (err) => console.error(err)
    )
  }
}

export const getReceiptItemTypeEnum = () => {
  return (dispatch) => {
    api.FETCH_RECEIPT_ITEM_TYPE_ENUMS(
      (types) => {
        dispatch({ type: SET_RECEIPT_ITEM_TYPE_ENUM, types: types })
      },
      (err) => console.error(err)
    )
  }
}

export const getDLNs = (workviewItem, callback) => {
  return (dispatch) => {
    api.GET_IMAGE_GROUP_DLNS(
      workviewItem.ImageGroupId,
      (dlnData) => {
        dispatch({ type: SET_RECEIPT_DLNS, data: dlnData })
        callback(dlnData)
      },
      (err) => console.error(err)
    )
  }
}

export const getCurrentUser = (id) => {
  return (dispatch) => {
    api.GET_USER_INFO_BY_USER(
      id,
      (data) => {
        // console.log(data)
        dispatch(setCurrentUserInfo(data))
      },
      (err) => {
        // dispatch(setCurrentUserInfoError(true))
        // dispatch(setCurrentUserInfoErrorDetails({ message: err.Message, code: err.Code}))
      }
    )
  }
}

export const setCurrentUserInfo = (data) => {
  return {
    type: SET_CURRENT_USER,
    currentUser: data,
  }
}

export const voidReceipt = (voidReceipt) => {
  return (dispatch) => {
    // console.log('void receipt params', voidReceipt);
    api.VOID_RECEIPT(
      voidReceipt,
      (data) => {
        // console.log(data);
        // dispatch({type: SET_DB_RECEIPT_DETAILS, receipt: data})
        dispatch(getDbReceiptDetails(data.ReceiptNum))
        dispatch(setSuccessToast('Receipt Voided Successfully'))
      },
      (err) => {
        console.error(err)
        if (err.includes('Account now has a Negative balance!')) {
          dispatch(getDbReceiptDetails(voidReceipt.ReceiptNum))
          dispatch(setSuccessToast(err))
        } else dispatch(setErrorToast('Receipt Void Unsuccessful'))
      }
    )
  }
}

export const getRefundStatus = () => {
  return (dispatch) => {
    api.FETCH_STATUSES_BY_CATEGORY(
      'REFUND_STATUS',
      (data) => {
        dispatch(
          setRefundStatus(
            data.map((status) => {
              return {
                value: status.ID,
                label: status.Descr,
              }
            })
          )
        )
      },
      (err) => {
        console.error(err)
      }
    )
  }
}

export const getRefundLimit = (setLimit) => {
  return api.GET_APP_SETTING_BY_NAME('REFUND_OVERPAYMENT_LIMIT', (data) =>
    setLimit(parseFloat(data.VALUE))
  )
}

export const setRefundStatus = (refundStatuses) => {
  return {
    type: SET_REFUND_STATUS,
    data: refundStatuses,
  }
}

// export const PrintReceipt = () => {
//   return (dispatch, getState) => {
//     // console.log('Print the receipt....')
//   }
// }

export const setRedirectBackTo = (location) => {
  return (dispatch) => {
    dispatch({ type: SET_REDIRECT_BACK_TO, redirectBackTo: location })
  }
}

export const base64ToArrayBuffer = (base64) => {
  var binaryString = window.atob(base64)
  var binaryLen = binaryString.length
  var bytes = new Uint8Array(binaryLen)
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i)
    bytes[i] = ascii
  }
  return bytes
}
